import { useCallback, type PropsWithChildren } from 'react'
import { AccountLink, useSetReviewerInfo } from '~/entities/user'
import { useLogout } from '~/features/auth/logout'
import { ReleaseNotesBannerSuspended, ReleaseNotesSuspended } from '~/features/release-notes'
import { useFilters as useDocumentsFilters } from '~/pages/documents'
import { MainLayout } from '~/shared/ui'
import { SecureRoute } from './providers/auth-security'

export function PageBase({
  children,
  noFooter,
  onLogoClick,
}: PropsWithChildren<{
  noFooter?: boolean
  onLogoClick?: () => void
}>) {
  useSetReviewerInfo()
  const { logout } = useLogout()
  const { resetToInitialFilters: resetDocumentsFilters } = useDocumentsFilters()

  const handleLogoClick = useCallback(() => {
    resetDocumentsFilters()
    onLogoClick?.()
  }, [resetDocumentsFilters, onLogoClick])

  return (
    <SecureRoute>
      <MainLayout
        accountLink={<AccountLink logout={logout} />}
        noFooter={noFooter}
        onLogoClick={handleLogoClick}
        releaseNotes={<ReleaseNotesSuspended />}
        banner={<ReleaseNotesBannerSuspended />}
      >
        {children}
      </MainLayout>
    </SecureRoute>
  )
}
